var map = {
	"./GoogleIcon": 144,
	"./GoogleIcon.tsx": 144,
	"./MicrosoftIcon": 141,
	"./MicrosoftIcon.tsx": 141,
	"./ai_icon.png": 508,
	"./apple_logo.svg": 487,
	"./base_logo.png": 922,
	"./base_logo.svg": 44,
	"./chart_plot": 544,
	"./chart_plot.json": 544,
	"./chart_plot.png": 203,
	"./chart_plot_0.jpg": 746,
	"./chart_plot_1.jpg": 127,
	"./chart_plot_2.jpg": 512,
	"./chat.png": 515,
	"./cookieless.png": 804,
	"./google_logo.svg": 650,
	"./match_snippet.mp4": 581,
	"./microsoft_logo.svg": 791,
	"./player_stats.png": 365,
	"./team_stats.png": 541,
	"./tmp_chart_plot.png": 529,
	"./tmp_chart_plot_blurr.png": 495,
	"./tmp_mmm_icon (2).png": 185,
	"./tmp_mmm_icon.png": 338,
	"./tracker.png": 881,
	"./xavi.jpg": 375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 573;